export default "__VITE_ASSET__D2h2djPD__"